import React from "react";
import { Title, Text, Button } from "@mantine/core";
import errorImage from "../assets/undraw_bug_fixing_oc-7-a.svg";
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  reloadPage = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: "center", padding: "2em" }}>
          <img src={errorImage} width={"100%"} height={"300px"}></img>
          <Title size="h1" order={1}>
            Oops! Something went wrong!
          </Title>
          <Text style={{ marginTop: "1em" }}>
            Our team has been notified and will work to fix the issue as soon as
            possible. Please try again later.
          </Text>
          <Button
            variant="contained"
            uppercase
            onClick={this.reloadPage}
            style={{ marginTop: "2em" }}
          >
            Reload
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
